import React, { useEffect } from "react";
import { LogoIcon } from "./LogoIcon";
import contentData from "./data/content";
import { loginPageBrandLogoAndDesc } from "../../utils/utils";

// Hero Section Component
export const HeroSection: React.FC = () => {
  const [brand, setBrand] = React.useState("central-os");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const redirectUrl = params.get("redirect");
    let domain = "" as string;
    if (redirectUrl) {
      try {
        const url = new URL(redirectUrl);
        domain = url.hostname; // will give you "wret.com", "adsf.com", etc.
      } catch (err) {
        console.error("Invalid URL:", redirectUrl);
      }
    }

    let brand = "central-os";

    const appMap = {
      "design-studio": ["techpacks", "scout", "artifax", "texhpx"],
      "catalog-studio": ["catalogix", "client", "catalist"],
      "photo-studio": ["photogenix"],
    };

    if (domain) {
      Object.keys(appMap).forEach((service) => {
        appMap[service].forEach((app) => {
          if (domain.indexOf(app) > -1) {
            brand = service;
          }
        });
      });
    }

    setBrand(brand);
  }, []);

  const { icon, heading, description } = loginPageBrandLogoAndDesc[brand];
  return (
    <div className="hero-section">
      <div className="logo-container">
        <img src={icon}></img>
      </div>{" "}
      <div className="hero-content">
        <div className="hero-title">{heading}</div>
        <div className="hero-subtitle">{description}</div>
      </div>{" "}
    </div>
  );
};

export default HeroSection;
